<template>
    <div class="active">
        <el-card 
            shadow = "never"
            v-loading="loading" 
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading" 
        >
            <el-row>
                <el-col :span="9">
                    <el-form 
                    :model="ruleForm" 
                    :rules="rules" 
                    ref="ruleForm"
                    label-width="100px"
                    class="demo-ruleForm"
                    >   
                        <el-form-item
                            label="券号"
                            prop="voucherCode"
                        >
                            <el-col :span="10">
                                <el-input v-model="ruleForm.voucherCode.value1" :maxlength ="8"></el-input>
                            </el-col>
                            <el-col :span="1" :offset="1"> - </el-col>
                            <el-col :span="10">
                                <el-input v-model="ruleForm.voucherCode.value2" :maxlength ="8"></el-input>
                            </el-col>
                        </el-form-item>
                        
                        <el-form-item>
                            <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
                            <el-button @click="cancel">返回</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :span ="14" :offset="1">
                    <el-card>
                        <div slot="header" class="clearfix">
                            <span><i class="el-icon-error" style="color:red;"></i> 错误信息</span>
                            <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
                        </div>
                        <el-table
                        :data="errData"
                        height="400"
                        style="width: 100%">
                        <el-table-column
                            prop="code"
                            label="券号"
                            width="100">
                        </el-table-column>
                        <el-table-column
                            prop="status"
                            label="状态"
                            width="80">
                        </el-table-column>
                        <el-table-column
                            prop="location"
                            label="地点名称">
                        </el-table-column>
                    </el-table>
                    </el-card>
                    
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<style lang="less">
    .line{
        text-align: center;
    }
</style>
<script>
import requestMixin from '../../mixins/request'
import common from '../../mixins/common'
import axios from '../../env/axios'
import apis from '../../env/apis'
export default {
    mixins:[requestMixin,common],
    inject:['reload'],
    data(){
        var validatorQty = (rule,value,callback) => {
            let value1 = Number.isInteger(value.value1) ;
            let value2 = Number.isInteger(value.value2) ;
            if(value.value1 == ''){
                callback(new Error("第一个券号不能为空！"));
            }else{
                if(value.value1 != '' && value.value2 == ''){
                    let val = this.trim(value.value1);
                    //  console.log(value.value1.length)
                    if((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(val) == false){
                        callback(new Error("请填写大于0的数字"));
                        // console.log('请填写大于0的数字')
                    }else if(/[+]/g.test(value.value1)){
                        //console.log('包含加号')
                        callback(new Error("请输入大于0的数字"));
                    }else if(value.value1.length != 8){
                        // console.log('券号不为8位数字')
                        callback(new Error("请输入8位数的券号！"));
                    }
                    else{
                        //console.log('哈哈')
                        callback();
                    }
                }else if(value.value2 != '' && value.value1 != ''){
                    if((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value.value2) == false || (/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value.value1) == false){
                        callback(new Error("请填写大于0的数字"));
                        // console.log('两个验证都必须填写大于0的数字')
                    }else if(value.value2 - value.value1 < 0){
                        callback(new Error("第二位数要大于第一位数"));
                    }else if(value.value2 < 0 || value.value1 < 0){
                        callback(new Error("必须填写大于0的数字"));
                    }else if(/[+]/g.test(value.value2) || /[+]/g.test(value.value1)){
                        //console.log('包含加号')
                        callback(new Error("请输入大于0的数字"));
                    }else if(value.value2.length != 8 || value.value1.length != 8){
                        callback(new Error("请输入8位数的券号！"));
                    }else{
                        callback();
                    }
                }
            }
        }
        return {
           ruleForm:{
                voucherCode:{
                    value1:"",
                    value2:""
                },
                confirmQty : ''
            }, 
            rules:{
                voucherCode: [
                    { validator : validatorQty,required: true,trigger:'blur',type:'number'},
                    // { message: '请填写券号', trigger: 'blur' }
                ]
            },
            errData:[],
            loading:false
        }
    },
    created (){
       
    },
    mounted(){
        let { confirmQty } = this.$route.query;
        this.ruleForm.confirmQty = confirmQty ;
    },
    methods:{
         //确认券号信息
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    // console.log(this.ruleForm)
                    let { voucherCode } = this.ruleForm ;
                    let userId = sessionStorage.getItem("userId") ;
                    this.getUserLocation().then(res =>{
                        let code = res ;
                        let params = {
                            act :'closeCoupons',
                            from : voucherCode.value1,
                            to : voucherCode.value2 == "" ? voucherCode.value1 : voucherCode.value2,
                            loc : code,
                            userId
                        }
                        let maxVal = params.to - params.from ;
                        this.errData = [];
                        if(maxVal <= 500 && maxVal >= 0){
                            this.getUserLocation().then((res) =>{
                                let code = res ;
                                let checkParams = {
                                    act : 'checkrange' ,
                                    from : voucherCode.value1,
                                    to : voucherCode.value2 == "" ? voucherCode.value1 : voucherCode.value2,
                                    checkLocation : code ,
                                    checkStatus : "S",
                                    userId
                                }
                                this.checkedRange(checkParams,params,'核销'); 
                            })
                        }else{
                            this.loading = false;
                            this.alert('批量核销最多为500张！','warning')
                        }
                    })
                } else {
                    return false;
                }
            });
        },

        //点击取消，跳转到上一页
        cancel(){
            this.$router.go(-1)
        },
    }
}
</script>
